import React from "react";
import RetrievalAttorneyInformationBase from "./RetrievalAttorneyInformationBase";
import { RETRIEVAL_ATTORNEY_CONFIG } from "../retrievalAttorneyConfig";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";

const TrusteeAttorneyInformationForm = ({
  globalData,
  data,
  updateData,
  role,
  isDisabled,
}) => (
  <RetrievalAttorneyInformationBase
    cfg={RETRIEVAL_ATTORNEY_CONFIG.trustee}
    globalData={globalData}
    data={data}
    updateData={updateData}
    role={role}
    isDisabled={isDisabled}
  />
);

TrusteeAttorneyInformationForm.propTypes = RETRIEVE_GLOBAL_DATA_ROLE_DISABLED;

export default TrusteeAttorneyInformationForm;
